import { render } from "./ProfileTgBot.vue?vue&type=template&id=7b56d3b8"
import script from "./ProfileTgBot.vue?vue&type=script&lang=js"
export * from "./ProfileTgBot.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__